import {
  HOME_LOOKBOOK_MOBILE_FEATURE,
  HOME_LOOKBOOK_MOBILE_RAIL,
  HOME_LOOKBOOK_DESKTOP_FEATURE,
  HOME_LOOKBOOK_DESKTOP_RAIL,
} from './homeLookbook';
import { HomeLookbookTile } from './HomeLookbookTile';

/** Phone: full-width feature + tiered filmstrip (restored). */
function HomeLookbookMobile() {
  if (!HOME_LOOKBOOK_MOBILE_FEATURE) return null;

  return (
    <div className="lg:hidden">
      <div className="md:hidden">
        <HomeLookbookTile
          item={HOME_LOOKBOOK_MOBILE_FEATURE}
          priority
          className="aspect-[4/5] w-full max-h-[min(420px,72svh)]"
        />

        <p className="mt-4 mb-2 text-xs font-semibold uppercase tracking-wide text-slate-400">
          More looks · swipe
        </p>

        <div className="home-lookbook-strip-shell relative -mx-4">
          <div className="pointer-events-none absolute inset-y-0 left-0 z-[2] w-6 bg-gradient-to-r from-[#faf9ff] to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 z-[2] w-10 bg-gradient-to-l from-[#faf9ff] to-transparent" />

          <div className="home-lookbook-strip flex gap-3 overflow-x-auto scroll-smooth snap-x snap-mandatory px-4 pb-1">
            {HOME_LOOKBOOK_MOBILE_RAIL.map((item, index) => (
              <HomeLookbookTile
                key={item.id}
                item={item}
                priority={index === 0}
                className={`home-lookbook-strip__tile shrink-0 snap-start ${
                  index % 2 === 0
                    ? 'home-lookbook-strip__tile--tall'
                    : 'home-lookbook-strip__tile--compact'
                }`}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="home-lookbook-tablet hidden md:grid lg:hidden">
        <HomeLookbookTile
          item={HOME_LOOKBOOK_MOBILE_FEATURE}
          priority
          className="home-lookbook-tablet__feature"
          showIndex={1}
        />
        <div className="home-lookbook-tablet__stack">
          {HOME_LOOKBOOK_MOBILE_RAIL.map((item, index) => (
            <HomeLookbookTile
              key={item.id}
              item={item}
              priority={index === 0}
              className="home-lookbook-tablet__cell"
              showIndex={index + 2}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

/** Large screens: Art drop hero + 3-up top row + wide + tile bottom. */
function HomeLookbookDesktop() {
  const [topA, topB, topC, bottomWide, bottomEnd] = HOME_LOOKBOOK_DESKTOP_RAIL;
  if (!HOME_LOOKBOOK_DESKTOP_FEATURE || !topA || !topB || !topC || !bottomWide || !bottomEnd) {
    return null;
  }

  return (
    <div className="home-lookbook-desktop hidden lg:grid">
      <div className="home-lookbook-desktop__feature">
        <HomeLookbookTile item={HOME_LOOKBOOK_DESKTOP_FEATURE} priority className="h-full" />
      </div>

      <HomeLookbookTile item={topA} priority className="home-lookbook-desktop__slot home-lookbook-desktop__slot--a" />
      <HomeLookbookTile item={topB} className="home-lookbook-desktop__slot home-lookbook-desktop__slot--b" />
      <HomeLookbookTile item={topC} className="home-lookbook-desktop__slot home-lookbook-desktop__slot--c" />
      <HomeLookbookTile item={bottomWide} className="home-lookbook-desktop__slot home-lookbook-desktop__slot--wide" />
      <HomeLookbookTile item={bottomEnd} className="home-lookbook-desktop__slot home-lookbook-desktop__slot--end" />
    </div>
  );
}

export function HomeLookbookCollage() {
  return (
    <>
      <HomeLookbookMobile />
      <HomeLookbookDesktop />
    </>
  );
}
